import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if the user has already answered our compliance cookie checker
    const dynamicConsent = localStorage.getItem("investorlanes_cookies_consent");
    if (!dynamicConsent) {
      // Delay showing the pop-up slightly for a premium user experience
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleChoice = (consentType) => {
    localStorage.setItem("investorlanes_cookies_consent", consentType);
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 150, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 150, opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50 w-[92%] max-w-3xl bg-white/95 backdrop-blur-md p-5 rounded-2xl shadow-2xl border border-gray-100 flex flex-col md:flex-row items-center justify-between gap-4"
        >
          <div className="text-center md:text-left">
            <h4 className="text-sm font-bold text-gray-900 mb-1">🍪 We value your data privacy</h4>
            <p className="text-xs text-gray-500 leading-relaxed">
              InvestorLanes uses essential cookies for platform matching tools and Paystack tracking. 
              Read our <Link to="/cookie-policy" className="text-blue-600 hover:underline font-medium">Cookie Policy</Link> to learn more.
            </p>
          </div>

          <div className="flex items-center gap-2.5 w-full md:w-auto justify-center">
            <button
              onClick={() => handleChoice("declined")}
              className="text-xs text-gray-600 font-semibold px-4 py-2.5 rounded-xl bg-gray-100 hover:bg-gray-200 transition active:scale-95 whitespace-nowrap"
            >
              Decline Optional
            </button>
            <button
              onClick={() => handleChoice("accepted_all")}
              className="text-xs text-white font-semibold px-5 py-2.5 rounded-xl bg-blue-600 hover:bg-blue-700 shadow-md shadow-blue-500/10 transition active:scale-95 whitespace-nowrap"
            >
              Accept All
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
